"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globals = void 0;
var globals = {
  borderRadius: {
    noRadius: '0',
    pill: '10rem',
    sm: '0.2rem',
    lg: '0.3rem',
    "default": '0.25rem'
  },
  fontSize: {
    sm: '0.875rem',
    lg: '1.25rem',
    "default": '1rem',
    toggle: '1.25rem'
  },
  padding: {
    button: {
      sm: '0.25rem 0.5rem',
      lg: '0.5rem 1rem',
      "default": '0.375rem 0.75rem'
    }
  },
  border: {
    "default": '1px solid',
    bottomTop: '2px solid'
  }
};
exports.globals = globals;